import { useState } from "react";
import ButtonComponent from "../../../components/button/Button";
import Input from "../../../components/input";
import { setToken } from "../../../utils/token";
import { useNavigate } from "react-router-dom";

const LoginComponent = () => {
    const [username, setUsername] = useState();
    const [password, setPassword] = useState();
    const [error, setError] = useState();
    const navigate = useNavigate();
    const onSubmit = (e) => {
        e.preventDefault()
        if(username === "admin" && password == "12345678")
        {
            setToken({token: "logged in"})
            setError(null)
            navigate("/admin")
        }
        else
        {
            setError("You used wrong credentials")
        }
    }
  return (
    <div className="w-full flex justify-center min-h-screen items-center bg-color-white2">
      <div className="shadow-md px-20 py-14 bg-white">
        <div className="font-bold uppercase text-color-primary-dark2 text-center my-5 text-4xl">Mamba Hikers Admin Panel</div>
        <div>
          <div className="text-color-gray-dark italic my-5">Please provide your credentials to proceed</div>
          <div>
            {error && <div className="text-red-500 my-4">{error}</div>}
            <div>
              <Input label="Username" name="username" hasLabel onChange={(text) => setUsername(text)}/>
              <Input
                label="Password"
                name="password"
                hasLabel
                type="password"
                onChange={(text) => setPassword(text)}
              />
            </div>
            <div onClick={onSubmit}>
              <ButtonComponent type={"login"} name={"Login"}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginComponent;
